'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main', {
    url: '/admin',
    template: '<oem-main></oem-main>',
    params: { linkTo: 'oem_main.company_edit', listTitle: '顧客 一覧' }
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem_main/oem_main.routes.js